import type { SVGProps } from 'react';
const SvgEmojiSymbols = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#emoji_symbols_svg__a)">
      <path d="M11 2H3v2h8V2ZM6 11h2V7h3V5H3v2h3v4ZM20.182 12.404l-7.778 7.778 1.414 1.414 7.778-7.778-1.414-1.414ZM14.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM19.5 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM15.5 11A2.5 2.5 0 0 0 18 8.5V4h3V2h-4v4.51c-.42-.32-.93-.51-1.5-.51a2.5 2.5 0 0 0 0 5ZM9.74 15.96l-1.41 1.41-.71-.71.35-.35a2.499 2.499 0 0 0-1.77-4.27 2.499 2.499 0 0 0-1.77 4.27l.35.35-1.06 1.06c-.98.98-.98 2.56 0 3.54.5.5 1.14.74 1.78.74.64 0 1.28-.24 1.77-.73l1.06-1.06 1.41 1.41 1.41-1.41-1.41-1.41 1.41-1.41-1.41-1.43ZM5.85 14.2a.5.5 0 0 1 .35-.15.5.5 0 0 1 .35.15c.19.2.19.51 0 .71l-.35.35-.35-.36a.501.501 0 0 1 0-.7Zm0 5.65a.5.5 0 0 1-.35.15.5.5 0 0 1-.35-.15.513.513 0 0 1 0-.71l1.06-1.06.71.71-1.07 1.06Z" />
    </g>
    <defs>
      <clipPath id="emoji_symbols_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEmojiSymbols;
